<mat-form-field [ngClass]="cssClasses">
  <mat-label>{{displayLabel}}</mat-label>
  <mat-select [placeholder]="placeholder" multiple
              [formControl]="selectFormControl"
              (openedChange)="onSelectPanelToggle($event)"
              [attr.data-element]="'qa-element-multi-select'"
              [attr.data-qa]="qaAttr"
              [disabled]="disabled">
    <mat-select-trigger>
      {{selectFormControl.value ? selectFormControl.value[0] : ''}}
      <span *ngIf="selectFormControl.value?.length > 1"
            class="additional-selection">
            (+{{selectFormControl.value.length - 1}} {{selectFormControl.value?.length === 2 ? 'other' : 'others'}})
      </span>
    </mat-select-trigger>
    <div>
      <div *ngIf="searchable" class="select-search-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <input class="select-search-input" type="text"
               [formControl]="searchFormControl"
               [placeholder]="searchPlaceholder"
               (click)="$event.stopPropagation()">
      </div>
      <mat-option *ngIf="!hasActiveSearch()" [value]="SELECT_ALL" (click)="toggleAll()">Select All</mat-option>
      <mat-option
        *ngFor="let option of options" [value]="option"
        [class.search-hidden-option]="!isOptionVisible(option)"
        [class.disabled-option]="isOptionDisabled(option)"
        [disabled]="isOptionDisabled(option)"
        [matTooltip]="getOptionTooltip(option)"
        matTooltipPosition="right"
        (click)="togglePerOption()">
        {{option}}
      </mat-option>
    </div>
  </mat-select>
  <mat-error *ngIf="selectFormControl.invalid && (selectFormControl.touched || selectFormControl.dirty)">{{ requiredErrorMessage }}</mat-error>
</mat-form-field>

